import React from 'react';

import { ItemGroupProps } from 'types/ItemGroupProps';
import * as S from './styles';

interface RedirectMenuProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function RedirectMenu({ data, phoneWidth }: RedirectMenuProps) {
  function returnRightCompByType() {
    switch (data.type) {
      case 'card':
        return (
          <S.compCard>
            <p>{data?.items[0]?.name || 'No name'}</p>
          </S.compCard>
        );

      case 'aba':
        return (
          <S.compAba>
            {data.guidance_type === '0' && data?.items[0]?.file?.url && (
              <img src={data.items[0].file.url} alt={data.name} />
            )}

            <p>{data?.items[0]?.name || 'No name'}</p>

            {data.guidance_type === '1' && data?.items[0]?.file?.url && (
              <img src={data.items[0].file.url} alt={data.name} />
            )}
          </S.compAba>
        );

      case 'tabs':
        return (
          <S.compTabs>
            {data.guidance_type === '0' && data?.items[0]?.file?.url && (
              <img src={data.items[0].file.url} alt={data.name} />
            )}

            <p>{data?.items[0]?.name || 'No name'}</p>

            {data.guidance_type === '1' && data?.items[0]?.file?.url && (
              <img src={data.items[0].file.url} alt={data.name} />
            )}
          </S.compTabs>
        );

      default:
        return <p>Não definido</p>;
    }
  }

  return <S.container>{returnRightCompByType()}</S.container>;
}
